import { useEffect } from 'react'
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthProvider'

function SigninOidc() {
    let auth = useAuth();
    const navigate = useNavigate()
    useEffect(() => {
        async function signinAsync() {
            await auth?.signinRedirectCallback()
            // navigate('/')
        }
        signinAsync()
    }, [navigate])

    return (
        <div className="loader-backdrop">
            <Spinner animation="border" variant="primary" />
        </div>
    )
}

export default SigninOidc
